import React from 'react';

export default function PasswordSecurityInfo() {
    return (
        <div className="alert alert-info mt-3" style={{ borderRadius: '12px', border: 'none', backgroundColor: 'rgba(13, 127, 242, 0.05)' }}>
            <div className="d-flex">
                <i className="fas  fa-shield-alt mr-3 text-primary" style={{ fontSize: '1.2rem' }}></i>
                <div>
                    <h6 className="font-weight-bold mb-1" style={{ color: 'var(--gris-fonce)', fontSize: '0.9rem' }}>Sécurité du compte</h6>
                    <p className="small mb-0 text-muted">Utilisez au moins 8 caractères avec des lettres et des chiffres pour un mot de passe robuste.</p>
                </div>
            </div>
        </div>
    );
}
